import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import roJSON from "./ro.json";
import enJSON from "./en.json";
import itJSON from "./it.json";

const kSupportedLanguages = ['en', 'it', 'ro'];

function detectInitialLanguage() {
  const stored = localStorage.getItem('locale');
  if (stored && kSupportedLanguages.includes(stored)) {
    return stored;
  }
  const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
  if (kSupportedLanguages.includes(browserLang)) {
    return browserLang;
  }
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enJSON },
      it: { common: itJSON },
      ro: { common: roJSON },
    },
    lng: detectInitialLanguage(),
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: { escapeValue: false },
  });

export default i18n;
